import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const data = [
    { hour: '12 AM', work: 0, paidBreak: 0, unpaidLunch: 0 },
    { hour: '1 AM', work: 0, paidBreak: 0, unpaidLunch: 0 },
    // ... fill in other hours
    { hour: '8 AM', work: 1, paidBreak: 0, unpaidLunch: 0 },
    { hour: '9 AM', work: 1, paidBreak: 0, unpaidLunch: 0 },
    { hour: '10 AM', work: 0.75, paidBreak: 0.25, unpaidLunch: 0 },
    { hour: '11 AM', work: 0.5, paidBreak: 0, unpaidLunch: 0.5 },
    // ... continue filling in data
    { hour: '4 PM', work: 1, paidBreak: 0, unpaidLunch: 0 },
    { hour: '5 PM', work: 0, paidBreak: 0, unpaidLunch: 0 },
    // ... fill in remaining hours
];

const DemoGraph = () => (
    <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <XAxis dataKey="hour" />
            <YAxis />
            <Tooltip
                contentStyle={{ backgroundColor: '#333', color: '#fff', borderRadius: '5px' }}
                itemStyle={{ color: '#fff' }}
            />
            <Legend />
            <Bar dataKey="work" stackId="a" fill="#FFB74D" />
            <Bar dataKey="paidBreak" stackId="a" fill="#4DB6AC" />
            <Bar dataKey="unpaidLunch" stackId="a" fill="#E57373" />
        </BarChart>
    </ResponsiveContainer>

);

export default DemoGraph;
